
export default function PartnersHero() {
  return (
    <section 
      className="relative min-h-[70vh] flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/a10c8c51d80815df3bdf0607f7edde07.jpg')`
      }}
    >
      <div className="container mx-auto px-4 text-center text-white w-full">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Nos <span className="text-red-500">Partenaires</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed">
            Nous collaborons avec les leaders mondiaux de la sécurité électronique 
            pour vous offrir les meilleures solutions du marché.
          </p>
          <div className="flex flex-col sm:flex-row gap-8 justify-center items-center text-center">
            <div>
              <div className="text-4xl font-bold text-red-500">25+</div>
              <div className="text-gray-300">Marques partenaires</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-red-500">100%</div>
              <div className="text-gray-300">Produits certifiés</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-red-500">5 ans</div>
              <div className="text-gray-300">Garantie moyenne</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
